import { IUser } from '@/shared/api-client/models';

export function friendlyUser(value: any): string {

    if (!value) {

        return '';
    }

    const user = value as IUser;

    return `${user.firstName} (${user.identifier})`;
}
